module.exports = {
  API_ROOT: 'https://operator.507.eu/api'
}



// WEBPACK FOOTER //
// ./config/config.js